@if (data.component) {
  <div appCtrlFactory [data]="data"></div>
}
<!-- <ng-container *ngComponentOutlet="data.compoennt"></ng-container> -->
